const createCommonTeamsScore = (combinedSecondTierScores) => {
    const team1PartsScore = [];
    const team2PartsScore = [];
    combinedSecondTierScores.forEach((score) => {
        const teamScore = score.trim().split(":");
        team1PartsScore.push(typeof teamScore[0] !== "undefined" && teamScore[0] !== "" ? teamScore[0].trim() : "-");
        team2PartsScore.push(typeof teamScore[1] !== "undefined" && teamScore[1] !== "" ? teamScore[1].trim() : "-");
    });
    return [team1PartsScore, team2PartsScore];
};
export const getTeamsScore = (combinedSecondTierScores, team1AdditionalScore, team2AdditionalScore) => {
    const [team1PartsScore, team2PartsScore] = createCommonTeamsScore(combinedSecondTierScores);
    return [[...team1PartsScore, ...team1AdditionalScore], [...team2PartsScore, ...team2AdditionalScore]];
};
export const geTeamsScoreTennis = (combinedSecondTierScores) => {
    const [team1PartsScore, team2PartsScore] = createCommonTeamsScore(combinedSecondTierScores);
    return [[...team1PartsScore], [...team2PartsScore]];
};
//# sourceMappingURL=getTeamsScore.js.map